import axios from 'axios';
import { ref, readonly } from '@nuxtjs/composition-api';



export const usePricesForBox = (): any => {
  const data = ref<Record<string, any>>({});
  const error = ref<Record<string, any>>({});

  const loadPrices = async (skus: string[], configurations: string[] = []) => {
    try {
      const response = await axios.post('/sole-api/product/getPricesForBox', {
        skus,
        configurations
      });

      data.value = response.data;
    } catch (err) {
      skus.forEach(sku => {
        error.value[sku] = err;
      });
    }
  };

  return {
    loadPrices,
    data: readonly(data),
    error: readonly(error)
  };
};

export default usePricesForBox;
export * from './usePricesForBox';